import { ApprovalState } from '@lichtblick/types';

type WorkGroupWorkItem = {
  id: string;
  approvalState: ApprovalState;
};

export const getWorkgroupStatus = (
  groupId: number,
  items: WorkGroupWorkItem[] | null | undefined,
  statusLabel: ApprovalState,
  count: number,
) => {
  const urgentTask = items ? [...items].reverse().find((el) => el.approvalState === statusLabel) : null;

  const mostUrgentItemLink = `workorders/${groupId}/items/${urgentTask ? urgentTask.id : ''}`;

  return {
    type: statusLabel,
    counter: {
      count,
      link: mostUrgentItemLink,
    },
  };
};
